import dayjs from 'dayjs';
import { IComplex, ILot, IOrganization, IPart } from 'interfaces/main';
import { getQuart } from 'utils/help';

export const defaultPart: IPart = {
  value: null,
  title_de: null,
  title_ru: null,
  title_en: null,
  order: null,
  complexId: 0,
};

export const defaultLot: ILot = {
  id: null,
  unit: '',
  // title: '',
  // description: '',
  totalArea: null,
  suiteArea: null,
  balconyArea: null,
  plotArea: null,
  baths: null,
  rooms: null,
  floor: null,
  planType: null,
  // phone: '',
  // whatsapp: '',
  // contactName: '',
  price: null,
  // hiddenPrice: null,
  isArchived: false,
  purposeId: 1,
  purpose: null,
  furnishingStatusId: 1,
  furnishingStatus: null,
  completedStatusId: 2,
  completedStatus: null,
  typeId: 1,
  type: null,
  rentFrequencyId: null,
  rentFrequency: null,
  complexId: null,
  complex: null,
  regionId: 3,
  categoryId: 1,
  region: null,
  favourites: [],
  consultations: [],
  lotCover: null,
  lotPhotos: [],
};

export const defaultOrganization: IOrganization = {
  id: null,
  title: '',
  description_de: '',
  description_ru: '',
  description_en: '',
  email: '',
  phone: '',
  telegram: '',
  facebook: '',
  whatsapp: '',
  site: '',
  needBorder: false,
  logotype: null,
  complexes: [],
  lots: [],
  users: [],
};

export const defaultComplex: IComplex = {
  id: null,
  title: '',
  description_de: '',
  description_ru: '',
  description_en: '',
  longitude: null,
  latitude: null,
  quart: getQuart(dayjs().month()),
  year: dayjs().year(),
  rating: null,
  complexCover: null,
  complexPhotos: [],
  organizationId: null,
  organization: null,
  regionId: 1,
  region: null,
  amenities: [],
  locations: [],
  favourites: [],
  consultations: [],
  parts: [],
};

export const defaultValues = {
  part: defaultPart,
};
